import { AvatarProps } from 'shared/mui/Avatars';

import { AvatarStyled } from './AvatarStackAdd.styled';

export type AvatarStackAddProps = AvatarProps;

export const AvatarStackAdd = (props: AvatarStackAddProps): JSX.Element => (
  <AvatarStyled {...props}>+</AvatarStyled>
);
